import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ListingsContext } from '@/utils/context/ListingsContext';
import { mlsGetBounds, mlsGetStateValue, mlsIsState, mlsIsZip } from '@/utils/helpers';
import { MLSResult } from '@/utils/types/MLSResult';
import Location from '@/components/mls/Location';
import ListingType from '@/components/mls/ListingType';
import '@/styles/components/mls-widget.scss';

const MLSSearchWidget: React.FC = (): JSX.Element | null => {
    const navigate = useNavigate();
    const searchParams: URLSearchParams = new URLSearchParams() ;
    const listings: MLSResult = {
        results: [],
        totalListings: 0,
        perPage: 0,
        currentPage: 0,
        currentSort: 'modified_DEC',
        params: {},
    }
    
    const handlePageChange = ( newPage: number ) => { }
    const handleSortChange = ( sortValue: string ) => { }
    const handleSearchSubmit = async ( e: React.FormEvent<HTMLFormElement> ) => {
        e.preventDefault();
        const formData = new FormData( e.currentTarget );
        const params = new URLSearchParams();
        params.set( 'page', '1' );
        const equals: Array<string> = [];
        for ( const [ key, value ] of formData.entries()) {
            if ( value.toString() ) {
                if ( key === 'location' ) {
                    try {
                        if ( mlsIsState( value.toString() ) ) {
                            equals.push( 'State:' + mlsGetStateValue( value.toString() ) );
                        } else if ( mlsIsZip( value.toString() ) ) {
                            equals.push( 'Zip:' + value.toString() );
                        } else {
                            const location: Record<string, any> = await mlsGetBounds( value.toString() );
                            equals.push( 'location:' + location.string );
                            equals.push( 'bounds:' + [ location.bounds.northeast.lat, location.bounds.northeast.lng, location.bounds.southwest.lat, location.bounds.southwest.lng ].toString() );
                        }
                    } catch ( error ) {
                        console.error('Error processing location:', error);
                        throw error;
                    }
                } else {
                    equals.push( key + ':' + value.toString() );
                }
            }
        }
        if ( equals.length ) {
            params.set( 'equals', equals.join( ';' ) );
        }
        navigate( '/listings?' + params.toString() );
    }
    

    if ( listings ) {    
        return (
            <ListingsContext.Provider value={ {
                listings,
                searchParams,
                handlePageChange,
                handleSortChange,
                handleSearchSubmit,
            } }>
                <form className="mls-form" id="mls-search-widget-form" method="post">
                    <ListingType />
                    <Location />
                </form>
            </ListingsContext.Provider>
        );
    } else {
        return null;
    }
}
export default MLSSearchWidget;


